@import "../../../variables.scss";

.sectionCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  background: #ffffff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}

.sectionHeader {
  font-weight: 300;
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 24px;
  color: $color-grey;
}

.formGroup {
  color: $color-grey;
  width: 100%;

  label {
    line-height: 19px;
  }

  input::placeholder {
    opacity: 0.5;
  }
}

.checkmark {
  //https://stackoverflow.com/questions/21968531/how-to-draw-a-checkmark-tick-using-css <- modified this
  display: inline-block;
  transform: rotate(40deg);
  height: 13.5px;
  width: 7px;
  margin-left: 10px;
  border-bottom: 3px solid #78b13f;
  border-right: 3px solid #78b13f;
}

.cross {
  color: rgb(231, 63, 63);
  font-size: 1em;
  margin-left: 8px;
}

.cardHeader {
  font-size: 24px;
}

.redLabel {
  color: red;
}

.statement {
  background-color: rgba(235, 235, 235, 0.5);
  border-radius: 4px;
  padding: 16px 20px;
  white-space: pre-line;

  .title__disabled {
    font-size: 1.25rem;
    font-weight: normal;
  }
}

.disabled {
  opacity: 0.5;
  label {
    color: $color-grey;
  }

  input:disabled {
    background: white;
    border-color: #d9d9d9;
  }
}

.updateHeader {
  font-size: 1.25rem;
}

.statementSectionHeader {
  font-size: 1rem;
  font-weight: normal;
  margin-bottom: 10px;
}
